import './FeedbackDropdown.scss';

import { AuthContextInterface, withAuthContext } from '@amzn/awscat-react-components';
import { Box, ButtonDropdown, ButtonDropdownProps, NonCancelableCustomEvent } from '@amzn/awsui-components-react';
import { useState } from 'react';

import { appName } from '../../common/Localization';
import { getAppId, isAWSUser } from '../../common/util';
import { getFeedbackDropDownItems } from '../common/feedback-dropdown-helper';
import  BugAndFeatureRequest, { FeedbackType } from './feedback-window/BugAndFeatureRequest';
import FeedbackWindow from './feedback-window/FeedbackWindow';

type Props = AuthContextInterface & {
    variant?: ButtonDropdownProps.Variant | 'normal';
    buttonText: string;
};
function FeedbackDropdown({auth, variant, buttonText} : Props): JSX.Element | null {
    
    const [ showFeedback, setShowFeedback ] = useState(false);
    const [ showFeatureRequest, setFeatureRequest ] = useState(false);
    const [ showBugRequest, setBugRequest ] = useState(false);
    
    const onDropdownItemClick = (event: NonCancelableCustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
        if (event.detail.id === 'provideFeedback') {
            setShowFeedback(true);
        } else if (event.detail.id === 'suggestAFeature') {
            setFeatureRequest(true);
        } else if (event.detail.id === 'submitABug') {
            setBugRequest(true);
        }
    };

    return auth.isAuthenticated() ? (
        <span>
            <ButtonDropdown
                expandToViewport
                variant={variant}  
                items={getFeedbackDropDownItems(auth)}
                onItemClick={onDropdownItemClick}
                data-testid='haveFeedback'
            >
                {buttonText}
            </ButtonDropdown>
            {showFeedback ? (
                <span id='feedback-ui-container'>
                    <FeedbackWindow
                        appId={getAppId()}
                        closeModal={() => setShowFeedback(false)}
                        createdBy={auth.getUserInfo()?.userId}
                        srcApp={appName}
                    />
                </span>
            ) : null}
            {showFeatureRequest ? (
                <Box id='feedback-ui-container'>
                    <BugAndFeatureRequest closeModal={() => setFeatureRequest(false)} 
                        feedbackType = {FeedbackType.FEATURE} isAwsUser={isAWSUser(auth)} 
                        userEmail ={auth.getUserInfo().email}
                    />
                </Box>
            ) : null}
            {showBugRequest ? (
                <Box id='feedback-ui-container'>
                    <BugAndFeatureRequest closeModal={() => setBugRequest(false)} 
                        feedbackType = {FeedbackType.BUG} 
                        isAwsUser={isAWSUser(auth)} 
                        userEmail ={auth.getUserInfo().email}
                    />
                </Box>
            ) : null}
        </span>
    ) : null;
}

export default withAuthContext(FeedbackDropdown);
